import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const DrawLineIcon = ({
  size,
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs("svg", {
    ...svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.8 14.77",
    style: {
      ...svgProps.style,
      width: `${(typeof size === "number" ? size : size.width).toString()}px`,
      height: `${(typeof size === "number" ? size : size.height).toString()}px`
    },
    fill: color,
    children: [/*#__PURE__*/jsx("path", {
      d: "M12.29 14.41a.9.9 0 01-.63-.27.88.88 0 01-.25-.81l.59-2.94a2.86 2.86 0 01.79-1.48L20.85.85a3 3 0 014.1 0A2.9 2.9 0 0125 5l-8.11 8a2.89 2.89 0 01-1.48.79l-2.94.59zM22.9 1.8a1.13 1.13 0 00-.78.32l-8.06 8.06a1.18 1.18 0 00-.3.56l-.32 1.62 1.62-.36a1 1 0 00.56-.3l8.06-8a1.1 1.1 0 000-1.56 1.13 1.13 0 00-.78-.34z",
      transform: "translate(0 -.03)"
    }), /*#__PURE__*/jsx("path", {
      d: "M18 11.58a.9.9 0 01-.64-.27l-2.88-2.82a.91.91 0 011.28-1.28L18.59 10a.91.91 0 01-.59 1.58zM8.9 14.8h-8a.9.9 0 010-1.8h8a.9.9 0 010 1.8z",
      transform: "translate(0 -.03)"
    })]
  });
};

export { DrawLineIcon };
//# sourceMappingURL=DrawLineIcon.js.map
